import { render, staticRenderFns } from "./SyncStore.vue?vue&type=template&id=5e3c26d0&"
import script from "./SyncStore.vue?vue&type=script&lang=ts&"
export * from "./SyncStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports